import React, { Component } from "react";
import TopAgentInfoAndAddress from "views/Pma/PmaEditor/FourthPageComponents/TopAgentInfoAndAddress";
import BackPageImageContainer from "@/views/Pma/PmaEditor/FourthPageComponents/CustomAgentPages/BackPageImageContainer";
import CompassBackPage from "@/views/Pma/PmaEditor/FourthPageComponents/CustomAgentPages/CompassBackPage";
import JohnsonsQuadrantsTwo from "@/views/Pma/PmaEditor/FourthPageComponents/CustomAgentPages/JohnsonsQuadrantsTwo";
import YETwoPropertyHighlights from "./PropertyHighlights";
import BackpageBoxes from "views/Pma/PmaEditor/FourthPageComponents/BackpageBoxes";
import { Link } from "react-router-dom";
import QVFourTestimonial from "@/views/Pma/PmaEditor/FourthPageComponents/QVFourTestimonial";
import DesignDetails from "views/Pma/PmaEditor/FourthPageComponents/DesignDetails";
import ColorBlockQuadrantContainer from "views/Pma/PmaEditor/FourthPageComponents/ColorBlockQuadrantContainer";
import QuadrantContainer from "views/Pma/PmaEditor/FourthPageComponents/QuadrantContainer";
import AgentFocusColumn from "views/Pma/PmaEditor/FourthPageComponents/AgentFocusColumn";
import LocalEvents from "views/Pma/PmaEditor/FourthPageComponents/LocalEvents";
import { pmaActions } from "_store/_actions";
import { connect } from "react-redux";
import Volunteer from "./Volunteer";
import Organizations from "./Organizations";
import "./styles.scss";
import "views/Pma/PmaEditor/CommonEditor/ivyprestoFonts.scss";
import { BackPageFreshdeskUploadButton } from "views/Help/component";
import BackPagePhotoUploadButton from "./BackPagePhotoUploadButton";
import { GetOAuthToken, IsValidSessionSwitch } from "common/storage";
import { isUserAdmin } from "common/roles/role";
import { withStyles } from "@mui/styles";
import compose from "recompose/compose";
import styles from "views/Home/styles";

const DEFAULT_AGENT_FOCUS_SECTION_IMAGE =
  "https://d2onbxnrte2nim.cloudfront.net/non-covers/032526_PMA_BackCover_Graphic.png";

const AGENT_FOCUS_SECTION_IMAGE_V2 =
  "https://d2onbxnrte2nim.cloudfront.net/040226_PMA_BackCover_Graphic_muted.png";

// mlsAreaIDs that are allowed to use the "Custom Back Page" option.
const CUSTOM_BACK_PAGE_AREA_IDS = []; //remove for july

const isAdminSessionAccess = () => {
  try {
    const token = GetOAuthToken();
    const oauthData = token ? JSON.parse(token) : null;
    return (
      (oauthData && isUserAdmin(oauthData.roleID)) || IsValidSessionSwitch()
    );
  } catch (err) {
    return IsValidSessionSwitch();
  }
};

class FourthPageComponents extends Component {
  state = {
    showModuleMenu: false,
    showAdminModuleMenu: false,
    uploadedBackPagePhotoURL: null,
  };

  toggleModuleMenu = () => {
    this.setState((prevState) => ({
      showModuleMenu: !prevState.showModuleMenu,
      showAdminModuleMenu: false,
    }));
  };

  toggleAdminModuleMenu = () => {
    this.setState((prevState) => ({
      showAdminModuleMenu: !prevState.showAdminModuleMenu,
      showModuleMenu: false,
    }));
  };

  handleBackPagePhotoUploadSuccess = (imagePath, uploadMeta = {}) => {
    const { currentArea, agentData } = this.props;
    const { listgenUserID } = agentData;
    const mlsAreaID =
      uploadMeta.areaID != null && uploadMeta.areaID !== ""
        ? uploadMeta.areaID
        : currentArea.mlsAreaID;

    this.setState({
      uploadedBackPagePhotoURL: imagePath,
      localIsBackPageModule: "CustomBackPage",
      showModuleMenu: false,
      showAdminModuleMenu: false,
    });

    if (this.props.updateCurrentAreaData) {
      this.props.updateCurrentAreaData({
        ...currentArea,
        backPagePhotoURL: imagePath,
      });
    }

    this.props.setBackPageModule(listgenUserID, mlsAreaID, "CustomBackPage");

    if (this.props.getNavbarInfo) {
      this.props.getNavbarInfo(listgenUserID);
    }
  };

  propertyHighlightsSwitchButton = (isPropHighlights) => {
    const { currentArea, agentData } = this.props;
    const { listgenUserID } = agentData;
    const { mlsAreaID } = currentArea;
    // Immediately update local state to switch the view
    this.setState({ localIsPropertyHighlights: isPropHighlights });
    // Make API call in background
    this.props.switchPropertyHighlightsPage(
      listgenUserID,
      mlsAreaID,
      isPropHighlights,
    );
    this.props.setBackPageModule(
      listgenUserID,
      mlsAreaID,
      "PropertyHighlights",
    );
  };

  backPageModuleSwitchButton = (backPageModule) => {
    const { currentArea, agentData } = this.props;
    const { listgenUserID } = agentData;
    const { mlsAreaID } = currentArea;
    // Immediately update local state to switch the view
    this.setState({
      localIsBackPageModule: backPageModule,
      showModuleMenu: false,
      showAdminModuleMenu: false,
    });
    // Featured page uses setIsPropertyHighlightsValue; keep it in sync when setBackPageModule is unavailable.
    this.props.switchPropertyHighlightsPage(
      listgenUserID,
      mlsAreaID,
      backPageModule === "PropertyHighlights",
    );
    this.props.setBackPageModule(listgenUserID, mlsAreaID, backPageModule);
  };

  // Helper method to create a bound function for a specific module
  getBackPageModuleSwitchButton = (moduleName) => {
    return () => this.backPageModuleSwitchButton(moduleName);
  };

  // Helper method to format module names for display
  formatModuleName = (moduleName) => {
    if (moduleName === "PropertyHighlights") {
      return "Featured Properties";
    }
    if (moduleName === "CompassBackPage") {
      return "Compass Marketing Page";
    }
    if (moduleName === "Quadrants") {
      return "Agent Focus";
    }
    if (moduleName === "AgentFocus") {
      return "Agent Focus";
    }
    if (moduleName === "AgentFocusVersion2") {
      return "Agent Focus (V2)";
    }
    if (moduleName === "AgentFocusColumn") {
      return "Agent Strategy Page";
    }
    if (moduleName === "DesignDetails") {
      return "Market Trends";
    }
    if (moduleName === "LocalEvents") {
      return "June Summer Spotlight";
    }
    if (moduleName === "CustomBackPage") {
      return "Custom Back Page";
    }
    if (moduleName === "BackPageBoxes") {
      return "Back Page Boxes";
    }

    // Insert space before capital letters (except the first one)
    return moduleName.replace(/([A-Z])/g, " $1").trim();
  };

  render() {
    const {
      printVersion,
      fromEditor,
      version,
      agentData,
      hoData,
      mlsAreas,
      coverPageDetails,
      testimonials,
      handlePropertyHighlightDialog,
      quarterlyAreaTable,
      bubbleBoxes,
      quadrantDetails,
      quadrantModalOpen,
      isDemo,
      sortSelected,
      hasTitle,
      propertyHighlightsTitle,
      hasSubtitle,
      propertyHighlightsSubtitle,
      hasFooterText1,
      propertyHighlightsFooterText1,
      hasFooterText2,
      propertyHighlightsFooterText2,
      altAgentData,
      volunteerDetails,
      setBackPageModule,
      agentFocusInfoList,
      designDetailsInfoList,
      showAllEditButtons,
    } = this.props;

    let { useQuadrants, useBackpageBoxes, currentArea } = this.props;
    const { mlsAreaID, backPageModule: backPageModuleRaw } = currentArea;
    const { listgenUserID } = agentData;
    const { localIsBackPageModule } = this.state;

    let isJohnsons = listgenUserID === "100988";

    const backPageModuleFromProps =
      backPageModuleRaw == null ||
      backPageModuleRaw === "" ||
      (typeof backPageModuleRaw === "string" && backPageModuleRaw.trim() === "")
        ? null
        : backPageModuleRaw;

    const backPageModule = localIsBackPageModule || backPageModuleFromProps;
    const defaultBackPageModule = "AgentFocusColumn";
    // "FeaturedProperties" is an alias for "PropertyHighlights" so either name
    // from the API (or local state) renders the property highlights module.
    // "AgentFocus" is remapped to "AgentFocusColumn" (Agent Strategy Page).
    const normalizeBackPageModule = (moduleName) => {
      if (moduleName === "FeaturedProperties") return "PropertyHighlights";
      if (moduleName === "AgentFocus") return "AgentFocusColumn";
      return moduleName;
    };
    const activeBackPageModule = normalizeBackPageModule(
      backPageModule || defaultBackPageModule,
    );

    let useCustomBackPage = false;
    let useCompassBackPage = false;
    let useLocalEvents = false;
    let useTemporaryPage = false;
    let usePropertyHighlights = false;
    let useDesignDetails = false;
    let useColorBlockQuadrants = false;
    let useOrganizations = false;
    let useVolunteer = false;
    let useAgentFocusColumn = true;
    useQuadrants = false;
    useBackpageBoxes = false;

    const backPageModuleMap = {
      LocalEvents: () => {
        useLocalEvents = true;
        usePropertyHighlights = false;
        useDesignDetails = false;
        useColorBlockQuadrants = false;
        useAgentFocusColumn = false;
        useQuadrants = false;
        useBackpageBoxes = false;
        useOrganizations = false;
        useVolunteer = false;
        useCustomBackPage = false;
        useCompassBackPage = false;
        useTemporaryPage = false;
      },
      PropertyHighlights: () => {
        usePropertyHighlights = true;
        useLocalEvents = false;
        useQuadrants = false;
        useBackpageBoxes = false;
        useDesignDetails = false;
        useColorBlockQuadrants = false;
        useAgentFocusColumn = false;
        useCustomBackPage = false;
        useVolunteer = false;
        useOrganizations = false;
        useCompassBackPage = false;
        useTemporaryPage = false;
      },
      BackPageBoxes: () => {
        useBackpageBoxes = true;
        useLocalEvents = false;
        useQuadrants = false;
        usePropertyHighlights = false;
        useOrganizations = false;
        useVolunteer = false;
        useCustomBackPage = false;
        useCompassBackPage = false;
        useDesignDetails = false;
        useColorBlockQuadrants = false;
        useAgentFocusColumn = false;
        useTemporaryPage = false;
      },
      CompassBackPage: () => {
        useCompassBackPage = true;
        useLocalEvents = false;
        useBackpageBoxes = false;
        useQuadrants = false;
        usePropertyHighlights = false;
        useOrganizations = false;
        useVolunteer = false;
        useCustomBackPage = false;
        useTemporaryPage = false;
        useDesignDetails = false;
        useColorBlockQuadrants = false;
        useAgentFocusColumn = false;
      },
      Quadrants: () => {
        useQuadrants = true;
        useLocalEvents = false;
        useBackpageBoxes = false;
        usePropertyHighlights = false;
        useOrganizations = false;
        useVolunteer = false;
        useCustomBackPage = false;
        useDesignDetails = false;
        useColorBlockQuadrants = false;
        useAgentFocusColumn = false;
        useCompassBackPage = false;
        useTemporaryPage = false;
      },
      DesignDetails: () => {
        useDesignDetails = true;
        useLocalEvents = false;
        useColorBlockQuadrants = false;
        useAgentFocusColumn = false;
        useQuadrants = false;
        useBackpageBoxes = false;
        usePropertyHighlights = false;
        useOrganizations = false;
        useVolunteer = false;
        useCustomBackPage = false;
        useCompassBackPage = false;
        useTemporaryPage = false;
      },
      AgentFocus: () => {
        useDesignDetails = false;
        useLocalEvents = false;
        useColorBlockQuadrants = true;
        useAgentFocusColumn = false;
        useQuadrants = false;
        useBackpageBoxes = false;
        usePropertyHighlights = false;
        useOrganizations = false;
        useVolunteer = false;
        useCustomBackPage = false;
        useCompassBackPage = false;
        useTemporaryPage = false;
      },
      AgentFocusVersion2: () => {
        useDesignDetails = false;
        useLocalEvents = false;
        useColorBlockQuadrants = true;
        useAgentFocusColumn = false;
        useQuadrants = false;
        useBackpageBoxes = false;
        usePropertyHighlights = false;
        useOrganizations = false;
        useVolunteer = false;
        useCustomBackPage = false;
        useCompassBackPage = false;
        useTemporaryPage = false;
      },
      AgentFocusColumn: () => {
        useDesignDetails = false;
        useLocalEvents = false;
        useColorBlockQuadrants = false;
        useAgentFocusColumn = true;
        useQuadrants = false;
        useBackpageBoxes = false;
        usePropertyHighlights = false;
        useOrganizations = false;
        useVolunteer = false;
        useCustomBackPage = false;
        useCompassBackPage = false;
        useTemporaryPage = false;
      },
      CustomBackPage: () => {
        useCustomBackPage = true;
        useDesignDetails = false;
        useLocalEvents = false;
        useColorBlockQuadrants = false;
        useAgentFocusColumn = false;
        useQuadrants = false;
        useBackpageBoxes = false;
        usePropertyHighlights = false;
        useOrganizations = false;
        useVolunteer = false;
        useCompassBackPage = false;
        useTemporaryPage = false;
      },
    };

    const applyBackPageModule =
      activeBackPageModule && backPageModuleMap[activeBackPageModule]
        ? backPageModuleMap[activeBackPageModule]
        : backPageModuleMap.AgentFocusColumn;
    applyBackPageModule();

    if (
      currentArea.isPropertyHighlights === true &&
      (localIsBackPageModule == null || localIsBackPageModule === "") &&
      !backPageModuleFromProps
    ) {
      backPageModuleMap.PropertyHighlights();
    }

    let showDesignDetailsLayout =
      useDesignDetails ||
      (activeBackPageModule === "AgentFocus" &&
        !useColorBlockQuadrants &&
        !useAgentFocusColumn);

    const designDetailsBackPageSwitchModule =
      activeBackPageModule === "AgentFocusVersion2"
        ? "AgentFocusVersion2"
        : activeBackPageModule === "AgentFocus"
          ? "AgentFocus"
          : "DesignDetails";

    // if (listgenUserID === "104597") {
    //   useOrganizations = false;
    //   useBackpageBoxes = false;
    //   useQuadrants = true;
    //   useLocalEvents = false;
    //   useCustomBackPage = false;
    //   usePropertyHighlights = false;
    // }
    // if (
    //   //DO NOT REMOVE, THEY WANT TO KEEP HIGHLIGHTS FOREVER
    //   listgenUserID === "109954"
    // ) {
    //   useBackpageBoxes = false;
    //   useQuadrants = false;
    //   useLocalEvents = false;
    //   useCustomBackPage = false;
    //   usePropertyHighlights = true;
    // }

    // if (listgenUserID === "105795") {
    //   useOrganizations = false;
    //   useBackpageBoxes = false;
    //   useQuadrants = false;
    //   useLocalEvents = false;
    //   useCustomBackPage = false;
    //   usePropertyHighlights = true;
    // }

    // if (listgenUserID === "100047") {
    //   useOrganizations = false;
    //   useBackpageBoxes = false;
    //   useQuadrants = false;
    //   useLocalEvents = true;
    //   useCustomBackPage = false;
    //   usePropertyHighlights = false;
    // }
    // // Show switch button when in editor mode and not in print version
    // const showSwitchButton = fromEditor;
    // const showSwitchButton =
    //   fromEditor &&
    //   agentData &&
    //   agentData.brokerageName &&
    //   agentData.brokerageName.toUpperCase() === "COMPASS";

    const showSwitchButton =
      fromEditor && (showAllEditButtons || listgenUserID === "116941");

    const { showModuleMenu, showAdminModuleMenu } = this.state;
    const shouldShowCompassOption =
      agentData.brokerageName && agentData.brokerageName.includes("Compass");
    const shouldShowCustomBackPageOption =
      CUSTOM_BACK_PAGE_AREA_IDS.includes(mlsAreaID) ||
      Boolean(
        this.state.uploadedBackPagePhotoURL || currentArea.backPagePhotoURL,
      );
    const preferredModuleOrder = [
      "DesignDetails",
      "PropertyHighlights",
      "CompassBackPage",
    ];
    const availableModules =
      listgenUserID === "116941"
        ? [
            ...preferredModuleOrder,
            ...Object.keys(backPageModuleMap).filter(
              (module) =>
                module !== "AgentFocus" &&
                !preferredModuleOrder.includes(module),
            ),
          ]
        : [
            "DesignDetails",
            "PropertyHighlights",
            "Quadrants",
            ...(shouldShowCompassOption ? ["CompassBackPage"] : []),
            ...(shouldShowCustomBackPageOption ? ["CustomBackPage"] : []),
          ];
    const resolvedMenuSelection =
      activeBackPageModule ||
      (useDesignDetails
        ? "DesignDetails"
        : useLocalEvents
          ? "LocalEvents"
          : useAgentFocusColumn
            ? "AgentFocusColumn"
            : useColorBlockQuadrants
              ? "AgentFocus"
              : showDesignDetailsLayout
                ? activeBackPageModule === "AgentFocusVersion2"
                  ? "AgentFocusVersion2"
                  : "DesignDetails"
                : useQuadrants
                  ? "Quadrants"
                  : "PropertyHighlights");
    const selectedModuleForMenu = availableModules.includes(
      resolvedMenuSelection,
    )
      ? resolvedMenuSelection
      : defaultBackPageModule;
    const adminAvailableModules = [
      ...preferredModuleOrder.filter((module) => module in backPageModuleMap),
      ...Object.keys(backPageModuleMap).filter(
        (module) =>
          module !== "AgentFocus" && !preferredModuleOrder.includes(module),
      ),
    ];
    const selectedModuleForAdminMenu = adminAvailableModules.includes(
      resolvedMenuSelection,
    )
      ? resolvedMenuSelection
      : defaultBackPageModule;

    const showAdminSelector = fromEditor && isAdminSessionAccess();

    return (
      <div className="ye2-first-left">
        <TopAgentInfoAndAddress
          currentArea={currentArea}
          printVersion={printVersion}
          agentData={agentData}
          isDemo={isDemo}
          hoData={hoData}
          version={version}
          coverPageDetails={coverPageDetails}
          quadrantModalOpen={quadrantModalOpen}
          mlsAreaID={mlsAreaID}
          fromEditor={fromEditor}
        />

        {fromEditor && (
          <>
            {showAdminSelector && (
              <>
                <div
                  className="back-page-module-admin-btn"
                  onClick={this.toggleAdminModuleMenu}
                  role="button"
                  tabIndex={0}
                >
                  <p>ADMIN:</p>
                  <p>Select Back Page</p>
                </div>
                {showAdminModuleMenu && (
                  <div className="back-page-module-admin-menu">
                    {adminAvailableModules.map((module) => (
                      <div
                        key={module}
                        className={`back-page-module-admin-menu-item ${
                          selectedModuleForAdminMenu === module ? "active" : ""
                        }`}
                        onClick={() => this.backPageModuleSwitchButton(module)}
                      >
                        {this.formatModuleName(module)}
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
            {isAdminSessionAccess() && (
              <BackPagePhotoUploadButton
                currentArea={currentArea}
                mlsAreas={mlsAreas}
                onUploadSuccess={this.handleBackPagePhotoUploadSuccess}
              />
            )}
            {showAllEditButtons && (
              <div className="backpage-upload-buttons-stack">
                <BackPageFreshdeskUploadButton
                  currentArea={currentArea}
                  showAllEditButtons={showAllEditButtons}
                />
              </div>
            )}
          </>
        )}
        {showSwitchButton && (
          <>
            <div
              className="back-page-module-container"
              onClick={this.toggleModuleMenu}
            >
              <div className="back-page-module-btn">
                <p>
                  {showModuleMenu
                    ? "Choose Your Back Page"
                    : "Choose Your Back Page"}
                </p>
              </div>
            </div>
            {showModuleMenu && (
              <div className="back-page-module-menu">
                {availableModules.map((module) => (
                  <div
                    key={module}
                    className={`back-page-module-menu-item ${
                      selectedModuleForMenu === module ? "active" : ""
                    }`}
                    onClick={() => this.backPageModuleSwitchButton(module)}
                  >
                    {this.formatModuleName(module)}
                  </div>
                ))}
              </div>
            )}
          </>
        )}
        {useOrganizations && !volunteerDetails ? (
          <div className="no-organizations">
            <p>Organizations List Pending</p>
          </div>
        ) : useOrganizations ? (
          <Organizations
            organizationsDetails={volunteerDetails}
            currentArea={currentArea}
            printVersion={printVersion}
            fromEditor={fromEditor}
            showAllEditButtons={showAllEditButtons}
            agentData={agentData}
            altAgentData={altAgentData}
            localEventsDetails={altAgentData?.localEventList}
            backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
              "Organizations",
            )}
          />
        ) : useVolunteer ? (
          <Volunteer
            volunteerDetails={volunteerDetails}
            currentArea={currentArea}
            printVersion={printVersion}
            fromEditor={fromEditor}
            showAllEditButtons={showAllEditButtons}
            agentData={agentData}
            altAgentData={altAgentData}
            localEventsDetails={altAgentData?.localEventList}
            backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
              "Volunteer",
            )}
          />
        ) : showDesignDetailsLayout || useDesignDetails ? (
          <DesignDetails
            currentArea={currentArea}
            quadrantDetails={quadrantDetails}
            agentFocusInfoList={agentFocusInfoList}
            designDetailsInfoList={designDetailsInfoList}
            mlsAreas={mlsAreas}
            printVersion={printVersion}
            fromEditor={fromEditor}
            showAllEditButtons={showAllEditButtons}
            testimonials={testimonials}
            hoData={hoData}
            agentData={agentData}
            backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
              designDetailsBackPageSwitchModule,
            )}
          />
        ) : useAgentFocusColumn ? (
          <AgentFocusColumn
            currentArea={currentArea}
            quadrantDetails={quadrantDetails}
            agentFocusInfoList={agentFocusInfoList}
            mlsAreas={mlsAreas}
            printVersion={printVersion}
            fromEditor={fromEditor}
            showAllEditButtons={showAllEditButtons}
            testimonials={testimonials}
            hoData={hoData}
            agentData={agentData}
            sectionBackgroundImageSrc={DEFAULT_AGENT_FOCUS_SECTION_IMAGE}
            backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
              "AgentFocusColumn",
            )}
          />
        ) : useColorBlockQuadrants ? (
          <ColorBlockQuadrantContainer
            currentArea={currentArea}
            quadrantDetails={quadrantDetails}
            agentFocusInfoList={agentFocusInfoList}
            mlsAreas={mlsAreas}
            printVersion={printVersion}
            fromEditor={fromEditor}
            showAllEditButtons={showAllEditButtons}
            testimonials={testimonials}
            hoData={hoData}
            agentData={agentData}
            sectionBackgroundImageSrc={DEFAULT_AGENT_FOCUS_SECTION_IMAGE}
            backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
              "AgentFocus",
            )}
          />
        ) : useQuadrants ? (
          <>
            <QuadrantContainer
              currentArea={currentArea}
              quadrantDetails={quadrantDetails}
              mlsAreas={mlsAreas}
              printVersion={printVersion}
              fromEditor={fromEditor}
              showAllEditButtons={showAllEditButtons}
              testimonials={testimonials}
              hoData={hoData}
              backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
                "Quadrants",
              )}
            />
            <QVFourTestimonial
              testimonials={testimonials}
              agentData={agentData}
              printVersion={printVersion}
              fromEditor={fromEditor}
              currentArea={currentArea}
              showAllEditButtons={showAllEditButtons}
            />
          </>
        ) : useBackpageBoxes ? (
          <BackpageBoxes
            currentArea={currentArea}
            agentData={agentData}
            quadrantDetails={quadrantDetails}
            fromEditor={fromEditor}
            showAllEditButtons={showAllEditButtons}
            bubbleBoxes={bubbleBoxes}
            mlsAreas={currentArea.mlsAreas}
            printVersion={printVersion}
            isDemo={isDemo}
            hoData={hoData}
            backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
              "BackPageBoxes",
            )}
          />
        ) : useTemporaryPage ? (
          <div className="highlight-editor-page">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "300px",
                padding: "40px 20px",
                background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                borderRadius: "12px",
                margin: "20px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                border: "2px dashed #dee2e6",
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  maxWidth: "400px",
                }}
              >
                <h3
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "#495057",
                    marginBottom: "12px",
                    fontFamily: "objektiv-mk2, sans-serif",
                  }}
                >
                  No Properties Selected
                </h3>
                <p
                  style={{
                    fontSize: "16px",
                    color: "#6c757d",
                    marginBottom: "30px",
                    lineHeight: "1.5",
                    fontFamily: "objektiv-mk2, sans-serif",
                  }}
                >
                  Get started by uploading your first property to showcase on
                  this page.
                </p>
                <Link
                  to={`/agent/property-highlights/${
                    currentArea && currentArea.mlsAreaID
                  }`}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:
                      "linear-gradient(135deg, #007bff 0%, #0056b3 100%)",
                    color: "white",
                    padding: "16px 32px",
                    borderRadius: "8px",
                    textDecoration: "none",
                    fontSize: "18px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 12px rgba(0, 123, 255, 0.3)",
                    border: "none",
                    cursor: "pointer",
                    minWidth: "280px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background =
                      "linear-gradient(135deg, #0056b3 0%, #004085 100%)";
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow =
                      "0 6px 20px rgba(0, 123, 255, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background =
                      "linear-gradient(135deg, #007bff 0%, #0056b3 100%)";
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                      "0 4px 12px rgba(0, 123, 255, 0.3)";
                  }}
                  onMouseDown={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                      "0 2px 8px rgba(0, 123, 255, 0.3)";
                  }}
                  onMouseUp={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow =
                      "0 6px 20px rgba(0, 123, 255, 0.4)";
                  }}
                >
                  <span
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      marginRight: "12px",
                      lineHeight: "1",
                    }}
                  >
                    +
                  </span>
                  Click Here to Upload a Property
                </Link>
              </div>
            </div>
          </div>
        ) : useCustomBackPage ? (
          <BackPageImageContainer
            agentData={agentData}
            currentArea={currentArea}
            fromEditor={fromEditor}
            backPagePhotoURL={
              this.state.uploadedBackPagePhotoURL ||
              currentArea.backPagePhotoURL
            }
            backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
              "CustomBackPage",
            )}
          />
        ) : useCompassBackPage ? (
          <CompassBackPage />
        ) : currentArea.isPropertyHighlights === true ||
          usePropertyHighlights ? (
          <YETwoPropertyHighlights
            currentSoldListings={sortSelected}
            handlePropertyHighlightDialog={handlePropertyHighlightDialog}
            quarterlyAreaTable={quarterlyAreaTable}
            agentData={agentData}
            printVersion={printVersion}
            fromEditor={fromEditor}
            showAllEditButtons={showAllEditButtons}
            currentArea={currentArea}
            title={hasTitle ? propertyHighlightsTitle : ""}
            subtitle={hasSubtitle ? propertyHighlightsSubtitle : ""}
            footerText1={hasFooterText1 ? propertyHighlightsFooterText1 : ""}
            footerText2={hasFooterText2 ? propertyHighlightsFooterText2 : ""}
            mlsAreaID={currentArea.mlsAreaID}
            testimonials={testimonials}
            propertyHighlightsSwitchButton={this.propertyHighlightsSwitchButton}
            backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
              "PropertyHighlights",
            )}
          />
        ) : useLocalEvents ? (
          Array.isArray(altAgentData?.localEventList) &&
          altAgentData.localEventList.length > 0 ? (
            <LocalEvents
              currentArea={currentArea}
              printVersion={printVersion}
              fromEditor={fromEditor}
              showAllEditButtons={showAllEditButtons}
              agentData={agentData}
              altAgentData={altAgentData}
              localEventsDetails={altAgentData.localEventList}
              propertyHighlightsSwitchButton={
                this.propertyHighlightsSwitchButton
              }
              backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
                "LocalEvents",
              )}
            />
          ) : null
        ) : isJohnsons ? (
          <JohnsonsQuadrantsTwo
            currentArea={currentArea}
            fromEditor={fromEditor}
            backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
              "Quadrants",
            )}
          />
        ) : useBackpageBoxes ? (
          <BackpageBoxes
            currentArea={currentArea}
            agentData={agentData}
            bubbleBoxes={bubbleBoxes}
            mlsAreas={currentArea.mlsAreas}
            hoData={hoData}
            printVersion={printVersion}
            fromEditor={fromEditor}
            showAllEditButtons={showAllEditButtons}
            isDemo={isDemo}
            backPageModuleSwitchButton={this.getBackPageModuleSwitchButton(
              "BackPageBoxes",
            )}
          />
        ) : (
          <div className="no-property-highlights">
            <div className="no-property-highlights-text">
              We are currently working on your featured properties page. This
              page will allow you to showcase up 5 properties. Please stay
              tuned!
            </div>
          </div>
        )}
        {/*{sortSelected && sortSelected.length === 2 && (
          <QVFourTestimonial
            testimonials={testimonials}
            agentData={agentData}
            printVersion={printVersion}
            currentArea={currentArea}
            fromEditor={fromEditor}
          />
        )}*/}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // currentArea: state.pma.currentArea,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    switchPropertyHighlightsPage: (
      listgenUserID,
      mlsAreaID,
      isPropHighlights,
    ) => {
      dispatch(
        pmaActions.switchPropertyHighlightsPage(
          listgenUserID,
          mlsAreaID,
          isPropHighlights,
        ),
      );
    },
    setBackPageModule: (listgenUserID, mlsAreaID, backPageModule) => {
      dispatch(
        pmaActions.setBackPageModule(listgenUserID, mlsAreaID, backPageModule),
      );
    },
    updateCurrentAreaData: (currentArea) => {
      dispatch(pmaActions.updateCurrentAreaData(currentArea));
    },
    getNavbarInfo: (listgenUserID) => {
      dispatch(pmaActions.getNavbarInfo(listgenUserID));
    },
  };
};
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(FourthPageComponents);
